import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

const Topbar = () => {
  const handleLogout = () => {
    localStorage.removeItem("admin");
    window.location.reload();
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#111827', boxShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
          Welcome Admin
        </Typography>
        <Button
          color="inherit"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: '#f44336',
            },
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
